import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UrlModal } from '../url.model';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private httpClient: HttpClient) { }
  singledokData(id){
    let params =new HttpParams();
    params= params.append('dokId',id)
      return this.httpClient
      .get<singleDoctorData>(
        UrlModal._URL +`/doc/doctor/${id}`,              
      )
      .pipe(
        map((data) => {        
          // return data.map((data) => {
            return data;                  
          // });
        })
      );
  }
  
  getcity(keyword:any){
    let payload ={
      keywords:keyword
    }
    return this.httpClient.post(UrlModal._URL+'/loc/searchcitybykeywords',payload )
  }
  
  getDoctorFromDb(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "12");
    console.log(params);
    return this.httpClient
      .get<DoctorData>(UrlModal._URL + "/doc/getdoc/", {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
        params: params,
      })
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }

}
export interface DoctorData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        name: string;
        doctorType: string;
        email: string;
        password: string;
        degree: [{ name: string }];
        profileStatus: {
          dailyLimit: boolean;
          scheduling: boolean;
        };
        isVerified: boolean;
        address: {
          line1: string;
          city: string;
          pincode: number;
          state: string;
        };
        clinic: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}
export interface singleDoctorData {
  map(arg0: (data: any) => void): any;
  status: number;
  message: string;
  data: {
    _id: string;
    name: string;
    doctorType: {
      isDeleted: boolean;
      _id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    };
    email: string;
    experience: number;
    password: string;
    consultationFee: { firstVisit: Number };
    mcId: string;
    membership: string;
    degree: string[];
    address: {
      line1: string;
      city: string;
      pincode: number;
      district: string;
      state: string;
    };
    clinic: string;
    profileStatus: {
      profile: boolean;
      dailyLimit: boolean;
      scheduling: boolean;
    };
    services: string[];
    isPhoneVerified: boolean;
    isVerified: boolean;
    profileImage: string;
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
